/**
 * Class dùng chung cho ô nhập và nhãn trong form.
 *
 * Sáu file từng khai lại `FIELD_CLASS`/`LABEL_CLASS` bằng tay — năm bản
 * `LABEL_CLASS` giống nhau tới từng ký tự. Sửa một sắc độ hay một cỡ chữ ở một
 * file là năm form còn lại lệch đi mà không ai thấy, vì mỗi form nằm ở một màn.
 */

export const FIELD_CLASS =
  'w-full rounded-lg border border-line bg-canvas px-3.5 py-2.5 text-[13px] text-ink outline-none transition-colors placeholder:text-ink-faint focus:border-accent';

/** Như `FIELD_CLASS` nhưng chữ đậm — dùng ở form có giá trị cần đọc nhanh. */
export const FIELD_CLASS_BOLD = `${FIELD_CLASS} font-semibold`;

/** Chữ đơn cách — cho ô nhập chuỗi phải so từng ký tự (proxy `host:port:user:pass`). */
export const FIELD_CLASS_MONO = `${FIELD_CLASS} font-mono`;

/** Chữ đậm + trạng thái khoá — form submit xong bị vô hiệu hoá trong lúc chờ. */
export const FIELD_CLASS_BOLD_DISABLABLE = `${FIELD_CLASS_BOLD} disabled:cursor-not-allowed disabled:opacity-50`;

export const LABEL_CLASS = 'mb-2 block text-[10px] font-bold uppercase tracking-wider text-ink-dim';

/** Nhãn của màn đăng nhập — to hơn một nhịp vì đứng một mình giữa trang. */
export const LABEL_CLASS_LOOSE =
  'mb-1.5 block text-[11px] font-bold uppercase tracking-[0.08em] text-ink-dim';
